import { realtimeApi } from '../../api';
import {
    UserRealtimeSubscriptionUpdateDTO
} from '../../types/realtime';

const RealtimeService = {

    getChannels: async () => {
        const response =
            await realtimeApi.fetchCustom('/channels');

        return response.data;
    },

    getMyChannels: async () => {
        const response =
            await realtimeApi.fetchCustom('/channels/me');

        return response.data;
    },

    createChannel: async (data: any) => {
        const response =
            await realtimeApi.addCustom('/channels', data);

        return response.data;
    },

    updateChannel: async (
        channelId: number,
        data: any
    ) => {

        const response =
            await realtimeApi.modifyCustom(
                `/channels/${channelId}`,
                data
            );

        return response.data;
    },

    deleteChannel: async (
        channelId: number
    ) => {

        const response =
            await realtimeApi.removeCustom(
                `/channels/${channelId}`
            );

        return response.data;
    },

    getUsers: async (
        page = 0,
        size = 10,
        search?: string,
        role?: string
    ) => {

        const params = new URLSearchParams();

        params.append('page', page.toString());
        params.append('size', size.toString());

        if (search) {
            params.append('search', search);
        }

        if (role) {
            params.append('role', role);
        }

        const response =
            await realtimeApi.fetchCustom(
                `/subscriptions/users?${params.toString()}`
            );

        return response.data;
    },

    getUserSubscriptions: async (
        userId: number
    ) => {

        const response =
            await realtimeApi.fetchCustom(
                `/subscriptions/users/${userId}`
            );

        return response.data;
    },

    updateUserSubscriptions: async (
        userId: number,
        dto: UserRealtimeSubscriptionUpdateDTO
    ) => {

        const response =
            await realtimeApi.modifyCustom(
                `/subscriptions/users/${userId}`,
                dto
            );

        return response.data;
    },
};

export default RealtimeService;